import Vue from "vue";

Vue.filter("lowercase", str => str.toLowerCase());